import { Image, ImageProps, Tooltip } from '@chakra-ui/react';
import { ReactNode, useEffect, useState } from 'react';

import { reportBrokenImage } from '../utils/reportBrokenImage';

type ProviderLogoProps = Omit<ImageProps, 'onError'> & {
  tooltip?: string;
  /** Rendered if `src` isn't provided or the image fails to load. Defaults to nothing. */
  fallback?: ReactNode;
  /** Controls whether the tooltip wraps the fallback. Defaults to `false` */
  fallbackGetsTooltip?: boolean;
};

export const ProviderLogo = ({
  src,
  tooltip,
  fallback = null,
  fallbackGetsTooltip = false,
  ...imageProps
}: ProviderLogoProps) => {
  const [imageFailed, setImageFailed] = useState(false);

  useEffect(() => {
    setImageFailed(false);
  }, [src]);

  if (!src || imageFailed) {
    if (!fallbackGetsTooltip) {
      return fallback;
    }

    return <Tooltip label={tooltip} shouldWrapChildren>{fallback}</Tooltip>
  }

  const image = (
    <Image
      src={src}
      onError={() => {
        setImageFailed(true);
        reportBrokenImage(src, { component: 'ProviderLogo' });
      }}
      {...imageProps}
    />
  );

  if (tooltip) {
    return <Tooltip label={tooltip} shouldWrapChildren>{image}</Tooltip>
  }

  return image;
};
